import React from 'react'
const FormWithoutSection = props => (
    <form onSubmit={props.onSubmit} autoComplete="off">
        {props.children}
    </form>
)
export default FormWithoutSection
